export const panValidate = (pannumber) => {
    var regex = /[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}/;
    if (regex.test(pannumber.toUpperCase()) && pannumber.length === 10) {
        return true;
    } else {
        return false;
    }
}